import React from "react";
import Letop from "../allpages/Letop";

export default () => (
  <div>
    <div>
      <div className="table">
        <table>
          <tr>
            <th className="col" />
            <th colSpan={6}>indicativus</th>
          </tr>
          <tr>
            <th className="col bor-bot" />
            <th colSpan={2}>praesens</th>
            <th colSpan={2}>imperfectum</th>
            <th colSpan={2}>futurum</th>
          </tr>
          <tr>
            <th className="col">1e ev.</th>
            <td>sum</td>
            <td>possum</td>
            <td>eram</td>
            <td>poteram</td>
            <td>ero</td>
            <td>potero</td>
          </tr>
          <tr>
            <th className="col">2e ev.</th>
            <td>es</td>
            <td>potes</td>
            <td>eras</td>
            <td>poteras</td>
            <td>eris</td>
            <td>poteris</td>
          </tr>
          <tr>
            <th className="col">3e ev.</th>
            <td>est</td>
            <td>potest</td>
            <td>erat</td>
            <td>poterat</td>
            <td>erit</td>
            <td>poterit</td>
          </tr>
          <tr>
            <th className="col">1e mv.</th>
            <td>sumus</td>
            <td>possumus</td>
            <td>eramus</td>
            <td>poteramus</td>
            <td>erimus</td>
            <td>poterimus</td>
          </tr>
          <tr>
            <th className="col">2e mv.</th>
            <td>estis</td>
            <td>potestis</td>
            <td>eratis</td>
            <td>poteratis</td>
            <td>eritis</td>
            <td>poteritis</td>
          </tr>
          <tr>
            <th className="col bor-bot">3e mv.</th>
            <td className="bor-bot">sunt</td>
            <td className="bor-bot">possunt</td>
            <td className="bor-bot">erant</td>
            <td className="bor-bot">poterant</td>
            <td className="bor-bot">erunt</td>
            <td className="bor-bot">poterunt</td>
          </tr>
          <tr>
            <th />
            <td colSpan={2}>
              <em>
                ik ben
                <br />
                ik kan
              </em>
            </td>
            <td colSpan={2}>
              <em>
                ik was
                <br />
                ik kon
              </em>
            </td>
            <td colSpan={2}>
              <em>
                ik zal zijn
                <br />
                ik zal kunnen
              </em>
            </td>
          </tr>
        </table>
      </div>

      <p>
        <Letop>
          Bij de bovenstaande tijden is het rijtje van <b>posse</b> eigenlijk
          hetzelfde als het rijtje van <b>esse</b>, maar dan met <b>pos-</b> of{" "}
          <b>pot-</b> ervoor.
        </Letop>
      </p>
      <p>
        <Letop>
          Verwar het imperfectum van <b>posse</b> niet met het
          plusquamperfectum. Bij het plusquamperfectum wordt de perfectumstam{" "}
          <b>potu-</b> gebruikt!
        </Letop>
      </p>

      <div className="table">
        <table>
          <tr>
            <th className="col" />
            <th colSpan={6}>indicativus</th>
          </tr>
          <tr>
            <th className="col bor-bot" />
            <th colSpan={2}>perfectum</th>
            <th colSpan={2}>plusquamperfectum</th>
            <th colSpan={2}>futurum exactum</th>
          </tr>
          <tr>
            <th className="col">1e ev.</th>
            <td>fui</td>
            <td>potui</td>
            <td>fueram</td>
            <td>potueram</td>
            <td>fuero</td>
            <td>potuero</td>
          </tr>
          <tr>
            <th className="col">2e ev.</th>
            <td>fuisti</td>
            <td>potuisti</td>
            <td>fueras</td>
            <td>potueras</td>
            <td>fueris</td>
            <td>potueris</td>
          </tr>
          <tr>
            <th className="col">3e ev.</th>
            <td>fuit</td>
            <td>potuit</td>
            <td>fuerat</td>
            <td>potuerat</td>
            <td>fuerit</td>
            <td>potuerit</td>
          </tr>
          <tr>
            <th className="col">1e mv.</th>
            <td>fuimus</td>
            <td>potuimus</td>
            <td>fueramus</td>
            <td>potueramus</td>
            <td>fuerimus</td>
            <td>potuerimus</td>
          </tr>
          <tr>
            <th className="col">2e mv.</th>
            <td>fuistis</td>
            <td>potuistis</td>
            <td>fueratis</td>
            <td>potueratis</td>
            <td>fueritis</td>
            <td>potueritis</td>
          </tr>
          <tr>
            <th className="col bor-bot">3e mv.</th>
            <td className="bor-bot">fuerunt</td>
            <td className="bor-bot">potuerunt</td>
            <td className="bor-bot">fuerant</td>
            <td className="bor-bot">potuerant</td>
            <td className="bor-bot">fuerint</td>
            <td className="bor-bot">potuerint</td>
          </tr>
          <tr>
            <th />
            <td colSpan={2}>
              <em>
                ik ben geweest
                <br />
                ik heb gekund
              </em>
            </td>
            <td colSpan={2}>
              <em>
                ik was geweest
                <br />
                ik had gekund
              </em>
            </td>
            <td colSpan={2}>
              <em>
                ik zal zijn geweest
                <br /> ik zal hebben gekund
              </em>
            </td>
          </tr>
        </table>
      </div>

      <p>
        <Letop>
          De bovenstaande tijden zijn compleet regelmatig, zolang je weet dat{" "}
          <b>fu-</b> de stam van <b>esse</b> is en <b>potu-</b> de stam van{" "}
          <b>posse</b> is.
        </Letop>
      </p>

      <div className="table">
        <table>
          <tr>
            <th className="col" />
            <th colSpan={4}>conjunctivus</th>
          </tr>
          <tr>
            <th className="col bor-bot" />
            <th colSpan={2}>praesens</th>
            <th colSpan={2}>imperfectum</th>
          </tr>
          <tr>
            <th className="col">1e ev.</th>
            <td>sim</td>
            <td>possim</td>
            <td>essem</td>
            <td>possem</td>
          </tr>
          <tr>
            <th className="col">2e ev.</th>
            <td>sis</td>
            <td>possis</td>
            <td>esses</td>
            <td>posses</td>
          </tr>
          <tr>
            <th className="col">3e ev.</th>
            <td>sit</td>
            <td>possit</td>
            <td>esset</td>
            <td>posset</td>
          </tr>
          <tr>
            <th className="col">1e mv.</th>
            <td>simus</td>
            <td>possimus</td>
            <td>essemus</td>
            <td>possemus</td>
          </tr>
          <tr>
            <th className="col">2e mv.</th>
            <td>sitis</td>
            <td>possitis</td>
            <td>essetis</td>
            <td>possetis</td>
          </tr>
          <tr>
            <th className="col bor-bot">3e mv.</th>
            <td className="bor-bot">sint</td>
            <td className="bor-bot">possint</td>
            <td className="bor-bot">essent</td>
            <td className="bor-bot">possent</td>
          </tr>
          <tr>
            <th />
            <td colSpan={2}>
              <em>
                ik ben
                <br />
                ik kan
              </em>
            </td>
            <td colSpan={2}>
              <em>
                ik was
                <br />
                ik kon
              </em>
            </td>
          </tr>
        </table>
      </div>

      <p>
        <Letop>
          Bij het praesens is het rijtje van <b>posse</b> weer hetzelfde als het
          rijtje van <b>esse</b>, maar dan met <b>pos-</b> of <b>pot-</b>{" "}
          ervoor.
        </Letop>
      </p>
      <p>
        <Letop>
          Het imperfectum is steeds de infinitivus plus de persoonsuitgangen.
        </Letop>
      </p>

      <div className="table">
        <table>
          <tr>
            <th className="col" />
            <th colSpan={4}>conjunctivus</th>
          </tr>
          <tr>
            <th className="col bor-bot" />
            <th colSpan={2}>perfectum</th>
            <th colSpan={2}>plusquamperfectum</th>
          </tr>
          <tr>
            <th className="col">1e ev.</th>
            <td>fuerim</td>
            <td>potuerim</td>
            <td>fuissem</td>
            <td>potuissem</td>
          </tr>
          <tr>
            <th className="col">2e ev.</th>
            <td>fueris</td>
            <td>potueris</td>
            <td>fuisses</td>
            <td>potuisses</td>
          </tr>
          <tr>
            <th className="col">3e ev.</th>
            <td>fuerit</td>
            <td>potuerit</td>
            <td>fuisset</td>
            <td>potuisset</td>
          </tr>
          <tr>
            <th className="col">1e mv.</th>
            <td>fuerimus</td>
            <td>potuerimus</td>
            <td>fuissemus</td>
            <td>potuissemus</td>
          </tr>
          <tr>
            <th className="col">2e mv.</th>
            <td>fueritis</td>
            <td>potueritis</td>
            <td>fuissetis</td>
            <td>potuissetis</td>
          </tr>
          <tr>
            <th className="col bor-bot">3e mv.</th>
            <td className="bor-bot">fuerint</td>
            <td className="bor-bot">potuerint</td>
            <td className="bor-bot">fuissent</td>
            <td className="bor-bot">potuissent</td>
          </tr>
          <tr>
            <th />
            <td colSpan={2}>
              <em>
                ik ben geweest
                <br />
                ik heb gekund
              </em>
            </td>
            <td colSpan={2}>
              <em>
                ik was geweest
                <br />
                ik had gekund
              </em>
            </td>
          </tr>
        </table>
      </div>

      <p>
        <Letop>
          De bovenstaande tijden zijn compleet regelmatig, zolang je weet dat{" "}
          <b>fu-</b> de stam van <b>esse</b> is en <b>potu-</b> de stam van{" "}
          <b>posse</b> is.
        </Letop>
      </p>
      <p>
        <Letop>
          Het futurum exactum en het perfectum conjunctivus hebben (afgezien van
          de 1e persoon enkelvoud) dezelfde vormen. Je moet dus aan de hand van
          de context bepalen of het een futurum exactum of een perfectum
          conjunctivus is.
        </Letop>
      </p>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/tables/esse-posse.js